import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { BaseService } from './base.service';
import { ApiResp } from '@app/types/global.type';

export interface AdminLoginResp {
  token: string;
  userEmail: string;
  userName: string;
  userId?: number;
}
export interface ChangePassword {
  currentPassword: string;
  newPassword: string;
  source?: string;
  client?: string;
}
@Injectable({
  providedIn: 'root',
})
export class AdminAuthService extends BaseService {
  login(payload: {
    userId: string;
    password: string;
    source?: string;
  }): Observable<AdminLoginResp> {
    payload.source = 'UI';
    return this.httpClient.post('/mypartner/user/login', payload).pipe(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      map((resp: any) => {
        if (resp.status) return resp.response;
        this.toastr.error(resp.message ?? 'Error');
        return null;
      }),
    );
  }

  changePassword(payload: ChangePassword): Observable<ApiResp> {
    payload.client = 'UI';
    return this.httpClient
      .put<ApiResp>('/mypartner/change/password', payload)
      .pipe(map((resp: ApiResp) => this.handleFormResp(resp)));
  }
}
